import { render, staticRenderFns, recyclableRender, components } from "./specification.vue?vue&type=template&id=6ede58e4&scoped=true&"
var renderjs
import script from "./specification.vue?vue&type=script&lang=js&"
export * from "./specification.vue?vue&type=script&lang=js&"
import style0 from "./specification.vue?vue&type=style&index=0&lang=css&"
import style1 from "./specification.vue?vue&type=style&index=1&id=6ede58e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ede58e4",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/specification/specification.vue"
export default component.exports